import type { AppConfig, AuthConfig, OktaConfig, ServerConfigurationResponse } from "./types";

const RUNTIME_CONFIG_JSON = "runtime-config.json";

export const getConfig = (): AppConfig => window.__APP_CONFIG__ as AppConfig;


export async function loadRuntimeConfig(): Promise<void> {
  const response = await fetch(RUNTIME_CONFIG_JSON, { cache: "no-cache" });
  if (!response.ok) {
    throw new Error(`GET ${RUNTIME_CONFIG_JSON} -> ${response.status}`);
  }
  const runtimeConfig = await response.json() as Partial<AppConfig>;
  const origin = window.location.origin;
  const appConfig: AppConfig = {
    env: runtimeConfig.env,
    apiBaseUrl: runtimeConfig.apiBaseUrl,
    apiKey: runtimeConfig.apiKey,
    auth: {
      redirectUri: origin + "/",
      postLogoutRedirectUri: origin + "/",
    } as AuthConfig,
    okta: {
      redirectUri: origin + "/login/callback",
      postLogoutRedirectUriBase: origin + "/",
    } as OktaConfig
  };

  window.__APP_CONFIG__ = appConfig;
}

export function applyServerConfiguration(response: ServerConfigurationResponse): void {
  const appConfig = window.__APP_CONFIG__;
  if (response.ssoConfig?.azureAd) {
    appConfig.auth = {
      ...appConfig.auth,
      clientId: response.ssoConfig.azureAd.clientId,
      authority: response.ssoConfig.azureAd.issuer
    };
  }
  if (response.ssoConfig?.okta) {
    appConfig.okta = {
      ...appConfig.okta,
      clientId: response.ssoConfig.okta.clientId,
      issuer: response.ssoConfig.okta.issuer
    };
  }
}

export function getVersionLabelFromServerResponse(response: ServerConfigurationResponse): string {
  return (
    (response.productInfo?.deploymentName ? response.productInfo.deploymentName + " " : "") +
    (response.productInfo?.version ? "v" + response.productInfo.version : "unknown version")
  );
}
